import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import "../App.css";
import Header from "./Header.js";
import { dateDifference, formatDate, formatDateText } from "./CommonFunctions";
import MakePayment from "./MakePayment";
import { Message } from "rsuite";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Paper,
  Container,
  Typography,
  Stack,
  Grid,
  Card,
  CardContent,
  Radio,
  RadioGroup,
} from "@mui/material";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
import { NumericFormat } from "react-number-format";
import { parseISO } from "date-fns";
import {
  AttachMoney as MoneyIcon,
  CreditCard as CreditCardIcon,
  AccountBalance as BankIcon,
  Receipt as ReceiptIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';

const options = { month: 'short', day: 'numeric', year: 'numeric' };
var totalAmountPaid = 0, totalCashAmount = 0, totalCreditAmount = 0, totalOtherAmount = 0;
var totalRent = 0;

const AddPayment = () => {
  const [searchStartDate, setSearchStartDate] = useState(formatDate(new Date(), -6));
  const [searchEndDate, setSearchEndDate] = useState(formatDate(new Date(), 1));
  const [roomNumber, setRoomNumber] = useState("");
  const [isMakePaymentComponentVisible, setIsMakePaymentComponentVisible] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [tenancyDetails, setTenancyDetails] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [tenancyId, setTenancyId] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [allRooms, setAllRooms] = useState([]);
  const [isRoomNumberInSearch, setIsRoomNumberInSearch] = useState(false);
  const [dateColumnFilter, setDateColumnFilter] = useState("actualPaymentDate");
  const [isMissingPayments, setIsMissingPayments] = useState(false);
  const [missingPayments, setMissingPayments] = useState([]);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortType, setSortType] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [sortModel, setSortModel] = useState("checkin");
  const [filterChecked, setFilterChecked] = useState(false);
  const url = process.env.REACT_APP_SERVER_URL;
  var balance = 0;
  var previd = 0;
  var totalRunningBalance = 0;
  let paymentid = null;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (queryParams.size != 0) {
      let rn = queryParams.get('roomNumber');
      let st = queryParams.get('searchStartDate');
      let et = queryParams.get('searchEndDate');
      setRoomNumber(rn);
      setSearchStartDate(st);
      setSearchEndDate(et);
      getAllRooms();
      getRentedTenancyDetailsByRoomIdAndDateRange(null, st, et, rn);
    } else {
      getAllRooms();
      getRentedTenancyDetailsByRoomIdAndDateRange(null, searchStartDate, searchEndDate, roomNumber);
    }
  }, []);

  const getAllRooms = async () => {
    try {
      await axios.get(`${url}/rooms`).then((responseForAllRooms) => {
        console.log(responseForAllRooms.data);
        setAllRooms(responseForAllRooms.data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleCloseEditPayment = () => {
    setPaymentId("");
    setIsMakePaymentComponentVisible(false);
    setPaymentDetails({});
  }

  const handleEditPayment = (paymentDetails) => {
    setPaymentId(paymentDetails.paymentId);
    setPaymentDetails(paymentDetails);
    setIsMakePaymentComponentVisible(true);
  }

  function calculateBalance(rent, paid_amount, id, nextIdIndex) {
    if (nextIdIndex == null) {
      if (previd != id) {
        balance = rent;
        previd = id;
      }
      if (balance < 0) {
        balance = paid_amount + balance;
      } else {
        balance = paid_amount - balance;
      }
      if (balance < 0) {
        return <label> - ${balance * -1}</label>
      }
      if (balance >= 0) {
        return <label> ${balance}</label>;
      }
      return balance;
    } else {
      totalRent = totalRent + rent;
      totalAmountPaid = totalAmountPaid + paid_amount;
      if (tenancyDetails[nextIdIndex]) {
        var nextId = tenancyDetails[nextIdIndex].id;
        if (nextId != id) {
          totalRunningBalance += balance;
          return <label> {totalRunningBalance} </label>;
        }
      } else {
        totalRunningBalance += balance;
        return <label> {totalRunningBalance} </label>;
      }
    }
  }

  function exportReportToExcel() {
    alert("converting this payment history page to excel doc");
  }

  function calculateCardandCashAmount(paymentData) {
    totalRent = 0;
    totalAmountPaid = 0;
    totalCashAmount = 0;
    totalCreditAmount = 0;
    totalOtherAmount = 0;
    for (var i = 0; i < paymentData.length; i++) {
      if (paymentData[i].cashAmount)
        totalCashAmount += paymentData[i].cashAmount;
      if (paymentData[i].creditCardAmount)
        totalCreditAmount += paymentData[i].creditCardAmount;
      if (paymentData[i].otherAmount)
        totalOtherAmount += paymentData[i].otherAmount;
    }
    totalAmountPaid += totalCashAmount + totalCreditAmount + totalOtherAmount;
    let tenancyToRentDict = {};
    for (var i = 0; i < paymentData.length; i++) {
      tenancyToRentDict[paymentData[i].id] = paymentData[i].rate;
    }
    console.log(tenancyToRentDict);
    for (var itr in tenancyToRentDict) {
      console.log(tenancyToRentDict[itr]);
      totalRent += tenancyToRentDict[itr];
    }
  }

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const getRentedTenancyDetailsByRoomIdAndDateRange = async (e, searchStartDate, searchEndDate, roomNumber) => {
    if (e) e.preventDefault();
    try {
      if (isMissingPayments && roomNumber) {
        await axios.get(`${url}/missingPayments/${roomNumber}`).then((responseForTenancyDetails) => {
          console.log(responseForTenancyDetails.data);
          setTenancyDetails(responseForTenancyDetails.data);
          setIsRoomNumberInSearch(true);
        });
      } else {
        if (roomNumber) {
          await axios.post(`${url}/rentedTenancyDetailsByRoomId/${roomNumber}`, {
            searchStartDate,
            searchEndDate,
            dateColumnFilter
          }).then(async (responseForTenancyDetails1) => {
            const dateColumnFilter = 'actualPaymentDate';
            await axios.post(`${url}/getMissingPayments`, {
              searchStartDate,
              searchEndDate,
              dateColumnFilter
            }).then(async (responseForTenancyDetails2) => {
              if (responseForTenancyDetails2 && responseForTenancyDetails2.data) {
                let resultArray = responseForTenancyDetails1.data;
                for (let itr in responseForTenancyDetails2.data) {
                  if (responseForTenancyDetails2.data[itr].roomid == roomNumber)
                    resultArray.push(responseForTenancyDetails2.data[itr]);
                }
                setTenancyDetails(resultArray);
              }
            });
            setIsRoomNumberInSearch(true);
            calculateCardandCashAmount(responseForTenancyDetails1.data);
          });
        } else {
          await axios.post(`${url}/payments/allPaymentsinDateRange`, {
            searchStartDate,
            searchEndDate,
            dateColumnFilter
          }).then(async (responseForTenancyDetails) => {
            console.log(responseForTenancyDetails.data);
            setTenancyDetails(responseForTenancyDetails.data);
            setIsRoomNumberInSearch(false);
            calculateCardandCashAmount(responseForTenancyDetails.data);
          });
        }
      }
      setSortModel("checkin");
    } catch (error) {
      console.log(error);
    }
  }

  const getPaymentHistoryByRoomIdAndDateRange = async (e) => {
    if (e) e.preventDefault();
    try {
      await axios.post(`${url}/paymentHistoryByRoomIdAndDateRange/${roomNumber}`, {
        searchStartDate,
        searchEndDate
      }).then((responseForPaymentHistory) => {
        console.log(responseForPaymentHistory.data);
      });
    } catch (error) {
      console.log(error);
    }
  }

  const getPaymentHistoryByTenantId = async (id) => {
    try {
      const response = await axios.get(`${url}/paymentHistory/${id}`);
      setTenancyId(id);
      getCustomerDetailsByTenantId(id);
      setPaymentHistory(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const getCustomerDetailsByTenantId = async (id) => {
    try {
      const response = await axios.get(`${url}/tenants/${id}/customers`);
      setCustomerDetails(response.data);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  const filteredRows = filterChecked
    ? tenancyDetails.filter((row) =>
      row.cashAmount || row.otherAmount)
    : tenancyDetails;

  const columns = [
    {
      field: 'roomid', headerName: 'Room', width: 60, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return <Link to={`/tenants/add/${currentRow.id}`} target="_blank">
          {currentRow.roomid}
        </Link>
      }
    },
    { field: 'paidBy', headerName: 'Paid by', width: 150, align: 'left' },
    {
      field: 'receiptNumber', headerName: 'Receipt Number', width: 120, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return currentRow.receiptNumber;
      }
    },
    {
      field: 'checkin', headerName: 'Tenancy Period', width: 220, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return <Link to={`/tenants/add/${currentRow.id}`} target="_blank">
          {parseISO(currentRow.checkin).toLocaleDateString('en-us', options)
            + '  -  ' +
            parseISO(currentRow.checkout).toLocaleDateString('en-us', options)
          }
        </Link>
      }
    },
    {
      field: 'rate', headerName: 'Rent', width: 90, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return <NumericFormat value={currentRow.rate} thousandSeparator prefix={'$'} displayType="text" />
      }
    },
    {
      field: 'paidAmount', headerName: 'Amount Paid', width: 90, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return <b><NumericFormat value={currentRow.paidAmount} thousandSeparator prefix={'$'} displayType="text" /></b>
      }
    },
    {
      field: 'cashAmount', headerName: 'Cash Amount', width: 120, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        if (currentRow.cashAmount)
          return <NumericFormat value={currentRow.cashAmount} thousandSeparator prefix={'$'} displayType="text" />
        return "-";
      }
    },
    {
      field: 'creditCardAmount', headerName: 'Credit Card Amount', width: 120, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        if (currentRow.creditCardAmount)
          return <NumericFormat value={currentRow.creditCardAmount} thousandSeparator prefix={'$'} displayType="text" />
        return "-";
      }
    },
    {
      field: 'otherAmount', headerName: 'Other', width: 100, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        if (currentRow.otherAmount)
          return <NumericFormat value={currentRow.otherAmount} thousandSeparator prefix={'$'} displayType="text" />
        return "-";
      }
    },
    {
      field: 'depositId', headerName: 'Deposit Details', width: 240, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        if (currentRow.depositId) {
          return <><Link>{currentRow.depositId}</Link> {` ($${currentRow.amount} on ${formatDateText(currentRow.depositDate)})`}
          </>
        }
        return "";
      }
    },
    {
      field: 'actualPaymentDate', headerName: 'Payment Date', width: 140, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        if (currentRow.actualPaymentDate)
          return parseISO(currentRow.actualPaymentDate).toLocaleDateString('en-us', options);
        return null;
      }
    },
    {
      field: 'status', headerName: 'Tenancy Status', width: 120, align: 'left',
      renderCell: (params) => {
        return params.row.status;
      }
    },
    {
      field: 'actions', headerName: 'Actions', width: 100, align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return <Link onMouseUp={handleCloseEditPayment}
          onTouchMove={handleCloseEditPayment}
          onClick={() => handleEditPayment(currentRow)}>Edit</Link>
      }
    },
  ];

  function CustomPagination(props) {
    return <>
      <b>Expected Rent:
        <NumericFormat value={totalRent} thousandSeparator prefix={'$'} displayType="text" /></b>
      <b>Amount Received:
        <NumericFormat value={totalAmountPaid} thousandSeparator prefix={'$'} displayType="text" /></b>
      <b>Cash Amount:
        <NumericFormat value={totalCashAmount} thousandSeparator prefix={'$'} displayType="text" /></b>
      <b>Credit Amount:
        <NumericFormat value={totalCreditAmount} thousandSeparator prefix={'$'} displayType="text" /></b>
      <b>Other Amount:
        <NumericFormat value={totalOtherAmount} thousandSeparator prefix={'$'} displayType="text" /></b>
      <GridPagination  {...props} />
    </>;
  }

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 3, mb: 2 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', 
                                                alignItems: 'center', mb: 1 }}>
            <Typography variant="h6" fontWeight="600">
              Payment Management
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <FormControl sx={{ minWidth: 150 }}>
                <InputLabel>Room Number</InputLabel>
                <Select
                  value={roomNumber}
                  onChange={(e) => { setRoomNumber(e.target.value) }}
                  label="Room Number"
                size="small"

                >
                  <MenuItem value="">
                    <em>All Rooms</em>
                  </MenuItem>
                  {allRooms.map((row, index) => (
                    <MenuItem key={index} value={row.id}>{row.id}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Start Date"
                type="date"
                size="small"
                value={searchStartDate}
                onChange={(e) => setSearchStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 180 }}
              />
              <TextField
                label="End Date"
                type="date"
                size="small"
                value={searchEndDate}
                onChange={(e) => setSearchEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 180 }}
              />
              <Button
                variant="contained"
                onClick={(e) => getRentedTenancyDetailsByRoomIdAndDateRange(e, searchStartDate, searchEndDate, roomNumber)}
                sx={{ textTransform: 'none', fontWeight: 600 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onMouseUp={() => { { setIsMakePaymentComponentVisible(false) } }}
                onTouchMove={() => { { setIsMakePaymentComponentVisible(false) } }}
                onClick={() => { setPaymentId(""); setPaymentDetails({}); setIsMakePaymentComponentVisible(true) }}
                sx={{ textTransform: 'none', fontWeight: 600 }}
              >
                Make Payment
              </Button>
            </Stack>
          </Box>

          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                
            <FormControlLabel  size="small"
              control={<Checkbox checked={filterChecked} onChange={(e) => setFilterChecked(e.target.checked)} />}
              label="Show only non-credit payments"
            />
            <FormControl>
              <RadioGroup size="small"
                row
                value={dateColumnFilter}
                onChange={(e) => setDateColumnFilter(e.target.value)}
              >
                <FormControlLabel value="systemPaymentDate" control={<Radio />} label="System Payment Date" />
                <FormControlLabel value="actualPaymentDate" control={<Radio />} label="Actual Payment Date" />
                <FormControlLabel value="checkinDate" control={<Radio />} label="Checkin Date" />
              </RadioGroup>
            </FormControl>
          </Box>

          {isRoomNumberInSearch && tenancyDetails.length > 0
            && searchStartDate > tenancyDetails[0].firstArrivalDate
            && <Box sx={{ mb: 2 }}>
              <Message className="fs-5" showIcon type="warning" closable>
                Guest moved in on {tenancyDetails[0].firstArrivalDate}. Please use this date as the search start date to get all relevant records
              </Message>
            </Box>}

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={2.4}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'primary.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <ReceiptIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Expected Rent</Typography>
                      <Typography variant="h6" fontWeight="600">
                        <NumericFormat value={totalRent} thousandSeparator prefix={'$'} displayType="text" />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'success.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <TrendingUpIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Total Amount</Typography>
                      <Typography variant="h6" fontWeight="600">
                        <NumericFormat value={totalAmountPaid} thousandSeparator prefix={'$'} displayType="text" />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'info.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <MoneyIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Cash Amount</Typography>
                      <Typography variant="h6" fontWeight="600">
                        <NumericFormat value={totalCashAmount} thousandSeparator prefix={'$'} displayType="text" />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'warning.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <CreditCardIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Credit Amount</Typography>
                      <Typography variant="h6" fontWeight="600">
                        <NumericFormat value={totalCreditAmount} thousandSeparator prefix={'$'} displayType="text" />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ bgcolor: 'error.main', color: 'white', p: 1.5, borderRadius: 2 }}>
                      <BankIcon />
                    </Box>
                    <Box>
                      <Typography variant="body" color="text.secondary">Other Amount</Typography>
                      <Typography variant="h6" fontWeight="600">
                        <NumericFormat value={totalOtherAmount} thousandSeparator prefix={'$'} displayType="text" />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Paper elevation={2} sx={{ borderRadius: 2 }}>
          {tenancyDetails.length ?
            <Box sx={{ height: 500, width: '100%' }}>
              <DataGrid
                rows={filteredRows}
                columns={columns}
                getRowId={(row) => row.paymentId + ' ' + row.id}
                slots={{
                  pagination: CustomPagination,
                }}
                sortModel={sortModel}
                onSortModelChange={(e) => setSortModel(e)}
                sx={{
                  border: "none",
                  "& .MuiDataGrid-cell": {
                    borderBottom: 1,
                    borderColor: "divider",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    bgcolor: "grey.50",
                    borderBottom: 2,
                    borderColor: "divider",
                  },
                }}
              />
            </Box>
            :
            <Message showIcon type="error" closable>
              No transactions in the selected Date Range
            </Message>
          }
        </Paper>
      </Container>

      {isMakePaymentComponentVisible && <MakePayment value={{ paymentDetails: paymentDetails, customerDetails: customerDetails }}
        getCustomerDetailsByTenantId={getCustomerDetailsByTenantId}
        getRentedTenancyDetailsByRoomIdAndDateRange={getRentedTenancyDetailsByRoomIdAndDateRange}
      />}
    </>
  );
};

export default AddPayment;